// GrowSetupContext.js
import React, { createContext, useContext, useState } from 'react';

const GrowSetupContext = createContext();

export const GrowSetupProvider = ({ children }) => {
  const [grow_setup, setGrowSetup] = useState(0);
  const [device_type, setDeviceType] = useState(0);

  return (
    <GrowSetupContext.Provider
      value={{
        grow_setup,
        setGrowSetup,
        device_type,
        setDeviceType,
      }}
    >
      {children}
    </GrowSetupContext.Provider>
  );
};

export const useGrowSetup = () => {
  const context = useContext(GrowSetupContext);
  if (!context) {
    throw new Error('useGrowSetup must be used within a GrowSetupProvider');
  }
  return context;
};
